/**
 * Raw Postgres/PostgREST error text (RLS violations, permission-denied, schema
 * errors) leaks internal implementation details — table names, legacy schema
 * naming (e.g. `degap_cycles`), column names — straight into the UI when
 * surfaced verbatim. Per docs/99-2-file/LEGACY_NAMING_RETIREMENT_LEDGER.md §1,
 * user-visible surfaces must never teach the legacy schema model.
 *
 * This maps known raw-DB error shapes to an actionable, user-facing message
 * and always logs the original for developers.
 */
export function toFriendlyDbError(rawError: string, context: string): string {
  console.error(`[${context}] Raw DB error:`, rawError);

  if (/violates row-level security policy/i.test(rawError)) {
    return "You don't have permission to do this in the current workspace. Try refreshing the page, or switch workspaces if you meant to act somewhere else.";
  }
  if (/permission denied for (table|function|relation)/i.test(rawError)) {
    return "You don't have permission to do this. If this keeps happening, try signing out and back in.";
  }
  if (/violates foreign key constraint|violates not-null constraint|violates unique constraint/i.test(rawError)) {
    return 'Something about this request conflicts with existing data. Please double-check the fields and try again.';
  }
  // Fallback: still avoid leaking raw SQL/relation identifiers (quoted names) if present.
  if (/"[a-z_]+"/i.test(rawError)) {
    return 'Something went wrong saving this. Please try again, or contact support if it persists.';
  }
  return rawError;
}
